import { render } from "./TableBox.vue?vue&type=template&id=63153937&scoped=true"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"

import "./TableBox.vue?vue&type=style&index=0&id=63153937&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63153937"]])

export default __exports__